import { SettingOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

const CardInfo = ({
  className,
  topLeftButton,
  onClick,
  showIcon,
  icon,
  onClickIcon,
  title,
  description,
  buttonTitle,
  onClickButton,
  selected,
  buttonDisabled,
  topRightButton,
  showStatus,
  onClickStatus,
}) => {
  return (
    <button
      type="button"
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
      }}
      tabIndex={onClick ? 0 : undefined}
      aria-label={
        onClick ? `${title || "Card"} - Click to activate` : undefined
      }
      onKeyDown={(e) => {
        if (onClick && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onClick(e);
        }
      }}
      className={`w-full flex flex-col justify-start items-center text-center shadow-lg hover:shadow-xl rounded-lg h-full border-0 bg-transparent p-6 ${
        onClick ? "cursor-pointer" : ""
      } ${className || ""}`}
    >
      <div className="flex flex-1 flex-row items-center">
        <div className="flex flex-row items-center justify-center w-7 h-7">
          {showIcon && (
              <button
              type="button"
              className="border-0 shadow-none bg-transparent cursor-pointer hover:text-custom_primary"
              onClick={(e) => {
                e.stopPropagation();
                if (onClickIcon) {
                  onClickIcon();
                }
              }}
            >
              {icon || <SettingOutlined />}
            </button>
          )}
          {topLeftButton}
        </div>
        <div className="flex flex-1 justify-center items-center py-1 px-4 leading-tight">
          {title}
        </div>
        {showStatus !== false && (
          <div className="flex flex-row justify-center items-center h-full">
            <button
              className={`w-4 h-4 rounded-full border-0 bg-none cursor-pointer flex self-center ${
                selected ? `bg-custom_green` : "bg-custom_lightgray"
              }`}
              onClick={(e) => {
                e.stopPropagation();
                if (onClickStatus) {
                  onClickStatus();
                }
              }}
              aria-label={selected ? "Selected" : "Not selected"}
              type="button"
              data-testid="status-link"
            />
          </div>
        )}
        {showStatus === false && topRightButton}
        {description && (
          <div className="flex flex-1 justify-center mt-1 mb-4 leading-tight">
            {description}
          </div>
        )}
      </div>
      {buttonTitle && (
        <button
          type="button"
          className={
            "bg-custom_primary border-custom_primary mt-4 rounded-lg text-white px-4 py-2"
          }
          onClick={() => {
            if (onClickButton) {
              onClickButton();
            }
          }}
          disabled={buttonDisabled || false}
        >
          {buttonTitle}
        </button>
      )}
    </button>
  );
};

CardInfo.propTypes = {
  className: PropTypes.string,
  topLeftButton: PropTypes.node,
  onClick: PropTypes.func,
  showIcon: PropTypes.bool,
  icon: PropTypes.node,
  onClickIcon: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  buttonTitle: PropTypes.string,
  onClickButton: PropTypes.func,
  selected: PropTypes.bool,
  buttonDisabled: PropTypes.bool,
  topRightButton: PropTypes.node,
  showStatus: PropTypes.bool,
  onClickStatus: PropTypes.func,
};

export default CardInfo;
